import { GetApp } from "../../App"
import { GetShip } from "../../App/Context"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { LocalizedMessage } from "../../Components/LocalizedMessage"

export function CruiseCalendarEmptyView() {
  const app = GetApp()!;
  const ship = GetShip();
  const t = app.getT("CruiseCalendarView");

  return (
    <div className="empty-ship-message">
      <LocalizedMessage html={true} message={(m) => m.noteText.startShip} replace={{ name: ship.name }} />
      <Block>
        <BlockRow actions={true} className="block-row-one-row">
          <BlockField>
            <button className="button default" onClick={() => {
              window.location.href = `logbook://app/ships/${ship.id}/launch`;
            }}
            >{t("start_ship")}</button>
          </BlockField>

        </BlockRow>
      </Block>
    </div>
  );
}
